import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Download, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { contactAPI } from '../../services/api';

const API = process.env.REACT_APP_BACKEND_URL;

const ContactsManager = () => {
  const [contacts, setContacts] = useState([]);

  const load = useCallback(async () => {
    try { const res = await contactAPI.getAll(); setContacts(res.data || []); }
    catch { toast.error('Failed to load contacts'); }
  }, []);

  useEffect(() => { load(); }, [load]);
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this contact?')) return;
    try { await contactAPI.delete(id); toast.success('Deleted'); load(); }
    catch { toast.error('Failed to delete'); }
  };

  const handleDownload = () => {
    const token = localStorage.getItem('admin_token');
    window.open(`${API}/api/admin/contacts/download?token=${token}`, '_blank');
  };

  return (
    <div className="max-w-4xl">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle>Contact Form Submissions</CardTitle>
            <CardDescription>{contacts.length} messages received</CardDescription>
          </div>
          <Button onClick={handleDownload} variant="outline" data-testid="download-contacts-csv">
            <Download className="w-4 h-4 mr-2" /> Download CSV
          </Button>
        </CardHeader>
        <CardContent className="space-y-3">
          {contacts.map(c => (
            <div key={c._id} className="p-4 bg-gray-50 rounded-lg flex justify-between items-start">
              <div>
                <p className="font-semibold text-gray-900">{c.name}</p>
                <p className="text-sm text-gray-500">{c.email} {c.phone && `- ${c.phone}`}</p>
                {c.company && <p className="text-sm text-gray-500">Company: {c.company}</p>}
                {c.service && <p className="text-xs text-emerald-600 mt-1">Service: {c.service}</p>}
                <p className="text-gray-700 text-sm mt-2">{c.message}</p>
                <p className="text-xs text-gray-400 mt-1">{new Date(c.submitted_at).toLocaleString()}</p>
              </div>
              <Button size="sm" variant="destructive" onClick={() => handleDelete(c._id)}><Trash2 className="w-4 h-4" /></Button>
            </div>
          ))}
          {contacts.length === 0 && <p className="text-center py-8 text-gray-500">No contact submissions yet.</p>}
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactsManager;
